import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

const Footer = () => {
  const [buildNumber, setBuildNumber] = useState('1.0.0');
  
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const textColor = useColorModeValue('gray.500', 'gray.400');

  useEffect(() => {
    fetch('/api/build-info')
      .then(res => res.json())
      .then(data => setBuildNumber(data.buildNumber))
      .catch(() => setBuildNumber('1.0.0'));
  }, []);

  return (
    <Box
      as="footer"
      position="sticky"
      bottom={0}
      w="100%"
      py={2}
      bg={bgColor}
      borderTopWidth="1px"
      borderColor={borderColor}
      zIndex="docked"
    >
      <Container maxW="container.xl" centerContent>
        <Text fontSize="xs" color={textColor}>
          Build {buildNumber} | &copy; {new Date().getFullYear()} RoleplAI
        </Text>
      </Container>
    </Box>
  );
};

export default Footer;